import React, { useState, useEffect, useLayoutEffect, useMemo, useCallback } from 'react';
import './style.css';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { listCoUser } from '../../../store/features/listCoUser';
import TeamCustomTable from '../../../components/dashboardcomponents/TeamComponents/TeamTable';
import { ReactComponent as Close } from '../../../assets/images/teamclose.svg';
import ActionButton from '../../../components/dashboardcomponents/ActionButton';
import ActionPopUp from '../../../components/dashboardcomponents/ActionPopUp';
import TeamGroupTable from '../../../components/dashboardcomponents/TeamComponents/TeamGroupTables';
import ButtonMain from '../../../components/common/ButtonMain';
import AgentMain from '../../../components/dashboardcomponents/TeamComponents/TeamsAgnetTab/AgentMain';
import SuspendedMain from '../../../components/dashboardcomponents/TeamComponents/SuspendedAgent/SuspendedMain';
import MultipleEmail from '../../../components/dashboardcomponents/MutliEmailSelect';
import AddGroupInput from '../../../components/dashboardcomponents/GroupInput';
import ChatLimit from '../../../components/dashboardcomponents/ChatLimit';
import SuperVisorMain from '../../../components/dashboardcomponents/TeamComponents/supervisor/SuperVisorMain';
import GroupSideBar from '../../../components/dashboardcomponents/GroupSideBar';
import TeamChatBot from '../../../components/dashboardcomponents/ChatBot/ChatBotMain';
import SelectInputTeam from '../../../components/dashboardcomponents/TeamSelectInput';
import DeletePopUp from '../../../components/dashboardcomponents/DeletePopUp';
import EditProfileMain from '../../../components/dashboardcomponents/TeamComponents/TeamEditProfile/EditProfileMain';
import SuspendedGroup from '../../../components/dashboardcomponents/TeamComponents/SuspendedGroups/SuspendedGroup';
import { getTabParamFromIndex, tabMapping } from '../../../utils/index';
import { suspendedListApi } from '../../../store/features/suspendedAgentList';
import { listGroupAPI } from '../../../store/features/listGroup';
import { unSuspendedGroupApi } from '../../../store/features/unSuspendGroup';
import { suspendGroupList } from '../../../store/features/listSuspendedGroup';
import { ListCoRoleName } from '../../../store/features/ListCoUserByRole';
import { selectActiveGroupSideBar } from '../../../Redux/group';
import { selectActiveChatLimit } from '../../../Redux/teamSlice';
import {
  getTeamManagementCountsWarmCache,
  patchTeamManagementCountsWarmCache,
} from '../../../utils/teamManagementCountsWarmCache';

const TeamSectionTable = [0, 1, 2, 3, 4, 5, 6];


function TeamManagment() {
  const [activeTab, setActiveTab] = useState(0);

  const [activePopUp, setActivePopUp] = useState(false);
  const [actionPopUp, setActionPopUp] = useState(false);
  const [actionButton, setActionButton] = useState(false);
  const [actionDeletePopup, setActionDeletePopup] = useState(false);

  const [chatLimitDetail, setChatLimitDetail] = useState({});
  const [getUserGroupList, setUserGroupList] = useState([]);
  const [getGroupUserList, setGroupUserList] = useState([]);
  const [usersCount, setUsersCount] = useState();
  const [agentsCountLength, setAgentsCountLength] = useState();
  const activeGroupSideBar = useSelector(selectActiveGroupSideBar);
  const activeChatLimit = useSelector(selectActiveChatLimit);
  const [counts, setCounts] = useState({
    allUsers: 0,
    agents: 0,
    supervisors: 0,
    suspendedAgents: 0,
    groups: 0,
    suspendedGroups: 0,
    loading: true
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedState, setSelectedState] = useState(TeamSectionTable[0]);

  const userData = useSelector((state) => state.loginToken);
  const uRole = userData.response?.user?.role_name;
  const businessId = userData?.response?.user?.business_id;

  useLayoutEffect(() => {
    if (!businessId) return;
    const wc = getTeamManagementCountsWarmCache();
    if (
      wc.hasFetched &&
      String(wc.businessId) === String(businessId) &&
      wc.counts
    ) {
      setCounts((prev) => ({
        ...prev,
        ...wc.counts,
        loading: false,
      }));
    }
  }, [businessId]);

  useEffect(() => {
    setActionButton(false);
  }, []);

  const refreshSuspendedCounts = async () => {
    try {
      const [
        suspendedAgentsRes,
        suspendedGroupsRes,
        activeAgentsRes,
        activeGroupsRes,
        allUsersRes
      ] = await Promise.all([
        dispatch(suspendedListApi()),
        dispatch(suspendGroupList()),
        dispatch(ListCoRoleName({ name: 'agent' })),
        dispatch(listGroupAPI()),
        dispatch(listCoUser())
      ]);


      if (allUsersRes?.payload?.status === 200) {
        setUsersCount(allUsersRes.payload.data || []);
      }

      setCounts(prev => {
        const next = {
          ...prev,
          suspendedAgents:
            suspendedAgentsRes?.payload?.status === 200
              ? suspendedAgentsRes.payload.data?.length || 0
              : 0,
          suspendedGroups:
            suspendedGroupsRes?.payload?.status === 200
              ? suspendedGroupsRes.payload.data?.length || 0
              : 0,
          agents:
            activeAgentsRes?.payload?.status === 200
              ? activeAgentsRes.payload.data?.length || 0
              : prev.agents,
          groups:
            activeGroupsRes?.payload?.status === 200
              ? activeGroupsRes.payload.data?.length || 0
              : prev.groups,
          allUsers:
            allUsersRes?.payload?.status === 200
              ? (Array.isArray(allUsersRes.payload.data)
                  ? allUsersRes.payload.data.length
                  : prev.allUsers)
              : prev.allUsers,
        };
        if (businessId) {
          patchTeamManagementCountsWarmCache(businessId, {
            allUsers: next.allUsers,
            agents: next.agents,
            supervisors: next.supervisors,
            suspendedAgents: next.suspendedAgents,
            groups: next.groups,
            suspendedGroups: next.suspendedGroups,
          });
        }
        return next;
      });
    } catch (err) {
      console.error('Error updating counts', err);
    }
  };

  const fetchAllCounts = useCallback(
    async (options = {}) => {
      const { background = false } = options;
      if (!businessId) return;
      if (!background) {
        setCounts((prev) => ({ ...prev, loading: true }));
      }
      try {
        const [suspendedRes, activeGroupRes, suspendedGroupRes, agentsRes] =
          await Promise.all([
            dispatch(suspendedListApi()),
            dispatch(listGroupAPI()),
            dispatch(suspendGroupList()),
            dispatch(
              ListCoRoleName({
                name: 'agent',
              }),
            ),
          ]);

        setCounts((prev) => {
          const next = {
            ...prev,
            suspendedAgents:
              suspendedRes?.payload?.status === 200
                ? suspendedRes.payload.data?.length || 0
                : 0,
            groups:
              activeGroupRes?.payload?.status === 200
                ? activeGroupRes.payload.data?.length || 0
                : 0,
            suspendedGroups:
              suspendedGroupRes?.payload?.status === 200
                ? suspendedGroupRes.payload.data?.length || 0
                : 0,
            agents:
              agentsRes?.payload?.status === 200
                ? agentsRes.payload.data?.length || 0
                : 0,
            loading: false,
          };
          patchTeamManagementCountsWarmCache(businessId, {
            allUsers: next.allUsers,
            agents: next.agents,
            supervisors: next.supervisors,
            suspendedAgents: next.suspendedAgents,
            groups: next.groups,
            suspendedGroups: next.suspendedGroups,
          });
          return next;
        });
      } catch (err) {
        console.error('Error fetching counts', err);
        setCounts((prev) => ({ ...prev, loading: false }));
      }
    },
    [businessId, dispatch],
  );

  useEffect(() => {
    if (!businessId) return;
    const wc = getTeamManagementCountsWarmCache();
    const warm =
      wc.hasFetched &&
      String(wc.businessId) === String(businessId) &&
      wc.counts;
    void fetchAllCounts({ background: Boolean(warm) });
  }, [businessId, fetchAllCounts]);

  // Separate useEffect for handling usersCount changes (from TeamCustomTable).
  // Skip while `usersCount` is still unset — otherwise we treat [] and force allUsers to 0,
  // wiping the warm-cache value before the table hydrates.
  useEffect(() => {
    if (usersCount === undefined || usersCount === null) {
      return;
    }
    const userCounts = Array.isArray(usersCount) ? usersCount : [];
    const agents = userCounts.filter(
      (user) => user.role === "agent" && user.isActive === true
    );

    setAgentsCountLength(agents?.length);

    setCounts((prev) => {
      const next = { ...prev, allUsers: userCounts.length };
      if (businessId) {
        patchTeamManagementCountsWarmCache(businessId, { allUsers: next.allUsers });
      }
      return next;
    });
  }, [usersCount, businessId]);
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    const tabParam = getTabParamFromIndex(tabName);
    navigate(`?tab=${tabParam}`, { replace: true });
  };



  useEffect(() => {
    const isComingFromSpecificURL = location.pathname === '/groupupdate/5';
    console.log('0000000000', isComingFromSpecificURL);
    if (isComingFromSpecificURL) {
      setSelectedState(1);
    }
  }, [location.state, navigate]);

  //= =================== Use Effect ===============================
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');

    if (tabParam && tabMapping[tabParam]) {
      const { tabIndex, stateIndex } = tabMapping[tabParam];
      setActiveTab(tabIndex);
      setSelectedState(stateIndex);
    } else {
      const isComingFromSpecificURL = location.pathname === '/groupupdate/5';
      if (isComingFromSpecificURL) {
        setActiveTab(5);
        setSelectedState(1);
        navigate('?tab=groups', { replace: true });
      }
    }
  }, []);

  const isTabActive = (tabName) => activeTab === tabName;

  const handleViewAllGroups = () => {
    setActiveTab(5); // Set to Groups tab
    setSelectedState(1); // Set to TeamGroupTable state
    navigate('?tab=groups', { replace: true });


  };



  useEffect(() => {
    return () => {
      if (!location.pathname.includes('/team')) {
        const url = new URL(window.location.href);
        url.search = '';
        window.history.replaceState({}, '', url);
      }
    };
  }, []);

  const registrationUIRender = useMemo(
    () => (
      <>
        {selectedState === 0 ? (
          <TeamCustomTable
            setUsersCount={setUsersCount}
            setChatLimitDetail={setChatLimitDetail}
            onViewAllGroups={handleViewAllGroups}
            setSelectedState={setSelectedState}
            setUserGroupList={setUserGroupList}
            onSuspenseChange={refreshSuspendedCounts}
          />
        ) : selectedState === 1 ? (
          <TeamGroupTable
            activeGroupSideBar={activeGroupSideBar}

            // setActiveGroupSideBar={setActiveGroupSideBar}
            setGroupUserList={setGroupUserList}
            onUnsuspend={refreshSuspendedCounts}
          />
        ) : selectedState === 2 ? (
          <TeamChatBot />
        ) : selectedState === 3 ? (
          <SuspendedGroup onSuspenseChange={refreshSuspendedCounts} />
        ) : selectedState === 4 ? (
          <AgentMain
            setChatLimitDetail={setChatLimitDetail}
            setSelectedState={setSelectedState}
            setActionPopUp={setActionPopUp}
            onViewAllGroups={handleViewAllGroups}
            setActionDeletePopup={setActionDeletePopup}
            // setActiveChatLimit={setActiveChatLimit}
            setAgentsCountLength={setAgentsCountLength}
            onSuspenseChange={refreshSuspendedCounts}

          />
        ) : selectedState === 5 ? (
          <SuspendedMain
            setSelectedState={setSelectedState}
            setActionPopUp={setActionPopUp}
            setActionDeletePopup={setActionDeletePopup}

            onSuspenseChange={refreshSuspendedCounts}

          />
        ) : selectedState === 6 ? (
          <EditProfileMain setSelectedState={setSelectedState} showHeader={true} />
        ) : selectedState === 7 ? (
          <SuperVisorMain
            setChatLimitDetail={setChatLimitDetail}
            setSelectedState={setSelectedState}
            setActionPopUp={setActionPopUp}
            // setActiveChatLimit={setActiveChatLimit}
            setActionDeletePopup={setActionDeletePopup}
          // setSupervisorCountLength={setSupervisorCountLength}
          />
        ) : null}
      </>
    ),
    [selectedState],
  );

  return (
    <div className="TeamManagment-main-container">
      {selectedState === 6 ? null : (
        <>
          <p className="TeamManagment-text">{t.TEAMTEXT}</p>
          <div className="Team-main-header">
            <div className="Team-text-section">
              <p
                className={`team-header-text ${isTabActive(0) ? 'TeamHeaderActive' : ''}`}
                onClick={() => {
                  handleTabClick(0);
                  setSelectedState(0);
                }}
              >
                {t.ALLUSERTEAM} ({counts.allUsers ?? 0})
              </p>

              <p
                className={`team-header-text ${isTabActive(1) ? 'TeamHeaderActive' : ''
                  }`}
                onClick={() => {
                  handleTabClick(1); setSelectedState(4);
                }}
              >
                {t.AGENTTEXT} ({counts.agents ?? 0})
              </p>
              {/* <p
                className={`team-header-text ${
                  isTabActive(2) ? 'TeamHeaderActive' : ''
                }`}
                onClick={() => {
                  handleTabClick(2); setSelectedState(7);
                }}
              >
                {t.SUPERVISOR} 
                {supervisorCountLength > 0 && `(${supervisorCountLength})`}
              </p> */}
              {(uRole === 'admin' || uRole === 'admin_with_billing') &&
                <p
                  className={`team-header-text ${isTabActive(3) ? 'TeamHeaderActive' : ''
                    }`}
                  onClick={() => {
                    handleTabClick(3); setSelectedState(5);
                  }}
                >
                  {t.SUSPENDEDAGENT} ({counts.suspendedAgents ?? 0})
                </p>
              }
              <p className="teamLine" />
              <p
                className={`team-header-text ${isTabActive(4) ? 'TeamHeaderActive' : ''
                  }`}
                onClick={() => {
                  handleTabClick(4); setSelectedState(2);
                }}
              >
                {t.CHATBOTTEXT}
              </p>
              <p
                className={`team-header-text ${isTabActive(5) ? 'TeamHeaderActive' : ''
                  }`}
                onClick={() => {
                  handleTabClick(5); setSelectedState(1);
                }}
              >
                {t.GROUPS} ({counts.groups ?? 0})
              </p>
              {(uRole === 'admin' || uRole === 'admin_with_billing') &&
                <p
                  className={`team-header-text ${isTabActive(6) ? 'TeamHeaderActive' : ''
                    }`}
                  onClick={() => {
                    handleTabClick(6); setSelectedState(3);
                  }}
                >
                  Suspended Groups ({counts.suspendedGroups ?? 0})
                </p>
              }
            </div>
            <div>
              {actionButton && <ActionButton setActionPopUp={setActionPopUp} />}
            </div>
          </div>
        </>
      )}
      {activePopUp && (
        <>
          <div className="overlay" />
          <div className="Team-PopUp-Container">
            <div className="Team-PopUp-Header">
              <p className="PopUp-Text01">{t.ADDMEMEBER}</p>
              <p className="PopUp-Text02" onClick={() => setActivePopUp(false)}>
                <Close />
              </p>
            </div>
            <p className="PopUp-Review-Text">{t.REVIEWTEXT}</p>
            <div className="PopUp-Email-Container">
              <p style={{ marginBottom: '5px' }}>{t.TITLE_EMAIL}</p>
              <MultipleEmail />
              <br />
              <p>{t.ASSIGNROLE}</p>
              <SelectInputTeam />
              <br />
              <p>{t.AddGroup}</p>
              <AddGroupInput />
              <br />
              <ButtonMain
                title="Copy invite link"
                className="buttonStyleTeam"
              />
              <ButtonMain
                title="Send Invite"
                className="buttonStyleEnable-team"
              />
            </div>
          </div>
        </>
      )}

      {actionDeletePopup && (
        <DeletePopUp
          setActionDeletePopup={setActionDeletePopup}
        />
      )}

      {activeChatLimit && <ChatLimit chatLimitDetail={chatLimitDetail} />}
      {actionPopUp && <ActionPopUp setActionPopUp={setActionPopUp} />}

      <div className="Team-Management-Main-Container">
        {registrationUIRender}

        {activeGroupSideBar && (
          <>
            <div className="overlay" />
            <GroupSideBar

              activeGroupSideBar={activeGroupSideBar}

              // setActiveGroupSideBar={setActiveGroupSideBar}
              getGroupUserList={getGroupUserList}
            />
          </>
        )}
      </div>
    </div>
  );


}

export default TeamManagment;
